var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-table",
        {
          ref: "table",
          attrs: {
            title: "시나리오 목록",
            columns: _vm.grid.columns,
            gridHeight: _vm.setheight,
            data: _vm.process.scenarios,
            merge: _vm.grid.merge,
            filtering: false,
            columnSetting: false,
            usePaging: false,
            editable: _vm.editable && !_vm.disabled,
            selection: "multiple",
            rowKey: "ramKrasAssessScenarioId",
          },
          on: {
            callbackProxy: _vm.callbackProxy,
            innerBtnClicked: _vm.innerBtnClicked,
          },
          scopedSlots: _vm._u([
            {
              key: "customArea",
              fn: function ({ props, col }) {
                return [
                  props.row["sopImprovementIds"] && props.row["ibmStepNames"]
                    ? _vm._l(
                        _vm.chipDatas(
                          props.row["sopImprovementIds"],
                          props.row["ibmStepNames"]
                        ),
                        function (item, index) {
                          return _c(
                            "q-chip",
                            {
                              key: index,
                              staticStyle: {
                                "margin-bottom": "4px !important",
                              },
                              attrs: {
                                color: item.color,
                                clickable: true,
                                "text-color": "white",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.linkClick(item, props.row)
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(item.title) + " ")]
                          )
                        }
                      )
                    : void 0,
                  _vm.editable &&
                  Boolean(props.row.ramKrasAssessScenarioId) &&
                  props.row.editFlag !== "C" &&
                  !_vm.disabled
                    ? _c(
                        "div",
                        [
                          _c(
                            "q-btn-group",
                            {
                              staticClass: "ColumInnerBtnGroup",
                              attrs: { outline: "" },
                            },
                            [
                              _c(
                                "q-btn",
                                {
                                  staticClass: "ColumInnerBtn",
                                  attrs: {
                                    icon: "add",
                                    color: "red-6",
                                    "text-color": "white",
                                    align: "center",
                                  },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.innerBtnClicked(col, props)
                                    },
                                  },
                                },
                                [_c("q-tooltip", [_vm._v(" 개선요청등록 ")])],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.editable && !_vm.disabled,
                        expression: "editable&&!disabled",
                      },
                    ],
                    attrs: {
                      isSubmit: _vm.isComplete,
                      url: _vm.completeUrl,
                      param: _vm.process,
                      mappingType: "PUT",
                      label: "공정[" + _vm.process.processName + "] 평가완료",
                      icon: "check",
                    },
                    on: {
                      beforeAction: _vm.completeProcess,
                      btnCallback: _vm.completeProcessCallback,
                    },
                  }),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: {
                          isSubmit: _vm.isSave,
                          url: _vm.saveUrl,
                          param: _vm.process.scenarios,
                          mappingType: "PUT",
                          label: "저장",
                          icon: "save",
                        },
                        on: {
                          beforeAction: _vm.saveScenario,
                          btnCallback: _vm.saveScenarioCallback,
                        },
                      })
                    : _vm._e(),
                  _vm.editable && !_vm.disabled
                    ? _c("c-btn", {
                        attrs: { label: "삭제", icon: "remove" },
                        on: { btnClicked: _vm.removeScenario },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }